<template>
  <div id="app" class="app__body" data-app>

	<!-- ------------ -->
	<!--    HEADER    -->
	<!-- ------------ -->
	<header 
		v-if="currentRouteName != 'profileview'"
		class="body__header"
	>
		<router-link class="header__logo" to="/">
			<div class="logo__outline"></div>
			<div class="logo__wrapper">
				<img src="./assets/iomico_logo_text.svg" 
					class="wrapper__image"/>
			</div>
		</router-link>

    </header>

	<!-- ----------------- -->
	<!--    MAIN CONTENT   -->
	<!-- ----------------- -->
	<transition 
		name="custom-classes-transition"
		enter-active-class="animated fadeIn"
		leave-active-class="animated fadeOut"
	>
		<router-view class="body__content"/>
	</transition>

	<!-- ------------ -->
	<!--   FOOTER   -->
	<!-- ------------ -->
	<footer class="body__footer">

	</footer>

  </div>
</template>

<script>

// @ is an alias to /src

export default {
  name: 'app',

  components: {
  },

  data: function(){
    return {

		isMenuOpen: false
		,contacts: {
			messengers: [
				{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
			]
			,socials: [
				{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
				,{
					name: ''
					,link: ''
					,image: ''
				}
			]
		}
	};
  }

	,created: function(){
	}

	,mounted: function(){

	}

	,computed: {
		currentRouteName() {
			return this.$route.name;
		}
	}

	,methods: {
		toggleMenu : function(){
			this.isMenuOpen = !this.isMenuOpen
		},
		onMenuItemClick : function(){
			this.isMenuOpen = false;
		}
		,getImageUrl : function(type, imgUrl){
			return require('./assets/'+ type+'/'+ imgUrl);
		}
	},

	watch:{
		$route (to, from){
			this.isMenuOpen = false;
			window.scrollTo({top: 0, behavior: 'smooth'}); 
		}
	} 
}
</script>
<style lang="scss">

@import "./assets/css/styles_small.scss";
@import "./assets/css/styles_large.scss";

@import "./assets/css/vuetify_patch.scss";

#app {
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
}

</style>
